const url = '/email-settings';
const Provider = 'EmailSettings';
const dbModel = 'EmailSettings';

export { url, Provider, dbModel };
